import { DestroyRef, Injectable } from '@angular/core';
import { AuthenticationResult } from '@azure/msal-browser';
import { User } from '../../domain/company/company';
import { EntityLogInfo } from '../../domain/logs/entity-log-info';
import { UserRepository } from '../../domain/user/user.repository';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StorageNames } from '../../constants/storage-names.provider';
import { SessionStorageService } from '../storage/session-storage.service';
import { MsalService } from '@azure/msal-angular';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  constructor(
    private userRepository: UserRepository,
    private msalService: MsalService,
    private destroyRef: DestroyRef,
    private sessionService: SessionStorageService,
    private localStorageService: LocalStorageService
  ) {}

  public saveUserProfile(authResult: AuthenticationResult) {
    const userProfile = authResult.account;
    const user: User = {
      id: userProfile.localAccountId,
      email: userProfile.username,
      firstName: userProfile.name?.split(' ')[0] ?? '',
      lastName: userProfile.name?.split(' ')[1] ?? '',
    };
    //console.log('User', user);
    const logInfo: EntityLogInfo = {
      category: 5 as any,
      changeTrigger: 'User Login/Signup from Azure AD',
    };
    this.userRepository
      .create(user, logInfo)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        this.sessionService.setItem(StorageNames.User, response);
      });
  }

  checkoutProfile(payload: AuthenticationResult) {
    const user: Partial<User> | null = this.sessionService.getItem(
      StorageNames.User
    );
    if (user && user.id === payload.account.localAccountId) {
      return;
    }
    this.saveUserProfile(payload);
  }

  getUserInfo(): Partial<User> | null {
    return this.sessionService.getItem<Partial<User>>(StorageNames.User);
  }

  logout() {
    this.sessionService.removeItem(StorageNames.User);
    this.sessionService.removeItem(StorageNames.Companies);
    this.localStorageService.removeItem(StorageNames.Companies);
    this.localStorageService.removeItem(StorageNames.SelectedCompany);
    this.msalService.logout();
  }
}
